import { render, staticRenderFns } from "./AirtimeData.vue?vue&type=template&id=b8fca3b2"
import script from "./AirtimeData.vue?vue&type=script&lang=js"
export * from "./AirtimeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports